// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"388":"9b7b72f3","525":"909a3c4a","759":"9f4a1c7d","845":"cbdc7510","991":"08bd45b4"}[chunkId] + ".chunk.js";
};